// Floor silhouettes in floors.png (wood rows 0-2; stone and cobble repeat them at +96 and +192). Each row describes the west, centre,
// and east bands (0..12, 12..20, 20..32); rows use the same north/south bands.
// Retain the corner cutouts too: a bounding rectangle would still support air.
const woodenFloorBands: Record<number, [number, number, number]> = {
    0: [0b000, 0b011, 0b011], 1: [0b000, 0b111, 0b111], 2: [0b000, 0b110, 0b110],
    3: [0b111, 0b111, 0b110], 4: [0b111, 0b111, 0b011], 5: [0b000, 0b011, 0b010],
    6: [0b000, 0b111, 0b000], 7: [0b000, 0b110, 0b010], 9: [0b010, 0b111, 0b111],
    32: [0b011, 0b011, 0b011], 33: [0b111, 0b111, 0b111], 34: [0b110, 0b110, 0b110],
    35: [0b110, 0b111, 0b111], 36: [0b011, 0b111, 0b111], 37: [0b010, 0b010, 0b010],
    38: [0b000, 0b010, 0b000], 39: [0b010, 0b010, 0b000], 40: [0b011, 0b111, 0b011],
    41: [0b111, 0b111, 0b111], 42: [0b110, 0b111, 0b110],
    64: [0b011, 0b011, 0b000], 65: [0b111, 0b111, 0b000], 66: [0b110, 0b110, 0b000],
    67: [0b000, 0b011, 0b000], 68: [0b000, 0b110, 0b000], 69: [0b010, 0b011, 0b000],
    70: [0b010, 0b110, 0b000], 71: [0b000, 0b010, 0b010], 73: [0b111, 0b111, 0b010],
}

/** Whether the soles touch visible floor art, in local tile coordinates. */
export const floorArtSupports = (tilesetId: string, position: number, x: number, y: number): boolean => {
    // Every floor material in the sheet reuses the wood's silhouettes, a block of three rows (96 cells) apart.
    const bands = tilesetId === "floors" ? woodenFloorBands[position % 96] : undefined
    if (!bands) return true
    const row = y < 12 ? 0 : y < 20 ? 1 : 2
    const bit = x < 12 ? 0b100 : x < 20 ? 0b010 : 0b001
    return (bands[row] & bit) !== 0
}
